module.exports = __webpack_public_path__ + "asset/gushiTitle_3IiSdcpr.png";